import { useEffect, useRef, useState } from 'react'

/**
 * Continuous visibility signal — unlike useReveal this stays live, so the hero
 * can pause its timer chain while scrolled off-screen.
 */
export function useInView<T extends HTMLElement = HTMLDivElement>(threshold = 0.05) {
  const ref = useRef<T | null>(null)
  const [inView, setInView] = useState(true)

  useEffect(() => {
    const el = ref.current
    if (!el || typeof IntersectionObserver === 'undefined') return

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) setInView(entry.isIntersecting)
      },
      { threshold },
    )

    observer.observe(el)
    return () => observer.disconnect()
  }, [threshold])

  return { ref, inView }
}
